import type { KambiClientEvent } from '@core/Areas/KambiClient/types'

export const getDataLayerPushedEventType = (kambiEvent: KambiClientEvent): DataLayerEvents => {
  if (kambiEvent.name !== 'dataLayerPushed') return 'Unknown'

  if (isBetPlacedEvent(kambiEvent)) {
    const isRewardUsed = kambiEvent.data.ecommerce.items.some(item => item.reward_type)
    return isRewardUsed ? 'RewardUsed' : 'BetPlaced'
  }

  return 'Unknown'
}

// =============
// Local Helpers
// =============

const isBetPlacedEvent = (kambiEvent: KambiClientEvent): kambiEvent is BetPlacedEvent => {
  const data = kambiEvent.data as BetPlacedEvent['data'] | undefined
  return !!data && data.event === 'purchase' && Array.isArray(data.ecommerce?.items)
}

// =====
// Types
// =====

type DataLayerEvents = 'BetPlaced' | 'RewardUsed' | 'Unknown'

type BetPlacedEvent = {
  name: 'dataLayerPushed'
  data: {
    event: 'purchase'
    ecommerce: { items: { reward_type?: string }[] }
  }
}
